import { render, staticRenderFns } from "./RealEstateKinds.vue?vue&type=template&id=29950758&scoped=true&"
import script from "./RealEstateKinds.vue?vue&type=script&lang=js&"
export * from "./RealEstateKinds.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateKinds.vue?vue&type=style&index=0&id=29950758&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29950758",
  null
  
)

export default component.exports